import React from 'react';
import { Button, Tooltip, Typography } from 'antd';

const { Text } = Typography;

// Цвет иконок в подвале карточки — тот же, что у BookmarkMenu, иначе соседние
// кнопки в одном ряду выглядят как из разных наборов.
export const FOOTER_ICON_COLOR = '#5b5f62';
// Счётчики «верно/неверно» цветом не выделяются: в одном ряду с ними стоят кнопки
// действий, и два цветных значка среди серых читались как из другого набора. Смысл
// несут сами знаки — галочка и крестик — и подпись в подсказке.

const ICON_SIZE = 20;

// Тег, а не div с ролью: <hr> — и есть разделитель, читалки знают его без подсказок.
// Собственных полей и отступов у него нет, поэтому они снимаются явно.
const VerticalDivider = () => (
    <hr aria-orientation="vertical"
        style={{ width: '1px', height: '20px', backgroundColor: '#e8e8e8', border: 'none', margin: 0 }} />
);

/**
 * Подвал карточки списка: равные по ширине блоки, разделённые вертикальной чертой.
 * Одну и ту же разметку повторяли CardInfoCard, WordInfoCard и QuizInfoCard —
 * держим её здесь, чтобы ряды кнопок во всех списках оставались одинаковыми.
 */
const InfoCardFooter = ({ children }) => {
    const blocks = React.Children.toArray(children).filter(Boolean);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '6px',
                paddingBottom: '6px',
                fontSize: '16px',
            }}
        >
            {blocks.map((block, index) => (
                // Ключ даёт сам React.Children.toArray: он проставляет их блокам,
                // и позиция в ключе больше не участвует
                <React.Fragment key={block.key}>
                    {index > 0 && <VerticalDivider />}
                    <div style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>{block}</div>
                </React.Fragment>
            ))}
        </div>
    );
};


/**
 * Кнопка-иконка подвала. Подпись живёт в подсказке и в aria-label: текста рядом
 * с иконкой нет, и без неё кнопка была бы безымянной для скринридера.
 */
export const InfoCardIconButton = ({ icon: Icon, title, onClick, color = FOOTER_ICON_COLOR }) => (
    <Tooltip title={title}>
        <Button
            type="text"
            aria-label={title}
            icon={<Icon style={{ width: ICON_SIZE, height: ICON_SIZE, fill: color }} />}
            onClick={(event) => {
                event.stopPropagation();
                onClick(event);
            }}
        />
    </Tooltip>
);


/**
 * Счётчик ответов: иконка плюс число. Значение может не прийти с сервера —
 * показываем ноль, а не пустоту, иначе строка счётчиков «прыгает».
 */
export const InfoCardCounter = ({ icon: Icon, title, value, color = FOOTER_ICON_COLOR }) => (
    <Tooltip title={title}>
        <span
            aria-label={`${title}: ${value || 0}`}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
            <Icon style={{ width: ICON_SIZE, height: ICON_SIZE, fill: color }} />
            <Text type="secondary">{value || 0}</Text>
        </span>
    </Tooltip>
);


export default InfoCardFooter;
